import { render } from "./CriticalPermissions.vue?vue&type=template&id=4aa2ef16"
import script from "./CriticalPermissions.vue?vue&type=script&lang=js"
export * from "./CriticalPermissions.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__